<template>
  <div class="social-step-editor-sidebar-advanced">    
    <div class="social-step-editor-sidebar-advanced__group">
      <shared-step-editor-input-field
        :input-value="piece.content"
        :maxlength="limit"
        :label="piece.name"
        class="social-step-editor-sidebar-advanced__textarea"
        :error="linkDangerous && piece.content.length ? `Link seems to be malicious or not existing` : ''"
        error-position="absolute"
        @input="onInput"
      />
      <shared-step-editor-input-counter
        :input="piece.content"
        :max="limit"
        class="social-step-editor-sidebar-advanced__counter"
      />
    </div>
    <!-- TODO uncomment when needed -->
    <!-- <shared-step-editor-loader v-if="false" :size="50" class="social-step-editor-sidebar-advanced__loader" /> -->
     <SocialStepEditorSidebarAdvancedLinkNotification
      v-if="notification"
      :notification="notification"
      @close="notification = null"
    />
    <button class="btn btn-default btn-primary w-100 mb-4" @click="$emit('close')">Return to Default</button>
  </div>
</template>

<script>
import SharedStepEditorInputField from '../../../shared/form/SharedStepEditorInputField';
import SharedStepEditorInputCounter from '../../../shared/form/SharedStepEditorInputCounter';
import SharedStepEditorLoader from '../../../shared/SharedStepEditorLoader.vue';
import SocialStepEditorSidebarAdvancedLinkNotification from './SocialStepEditorSidebarAdvancedLinkNotification';
import {isValidUrl} from '../../../../../../utility/isValidUrl.js';

export default {
  components: {
    SharedStepEditorInputField,
    SharedStepEditorInputCounter,
    SharedStepEditorLoader,
    SocialStepEditorSidebarAdvancedLinkNotification,
  },
  props: {
    piece: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
    },
    linkDangerous: {
      type: Boolean,
    },
    message: {
      type: String
    }
  },
  data: () => ({
    limit: 2000,
    notification: null,
  }),
  methods: {
    clearLinkNotification() {
      this.notification = null;
    },
    showNotification(status, message, dismissible = true) {
      this.notification = {status, message, dismissible};
    },   
    onInput: _.debounce(async function (link) {
      this.$emit('change-link', link);
    }, 500),
    onPickImage() {
      this.$emit('pick');
    },
  },
  watch: {    
    message: {
      handler(val) {
        if(!val.length) {
          this.clearLinkNotification();
          return;
        }
        this.showNotification('danger', val);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.social-step-editor-sidebar-advanced {
  padding: 24px 16px;
  &__group {
    margin-bottom: 10px;
  }
  &__textarea {
    width: 100%;
    word-break: break-word;
    border: none;
  }
  &__loader {
    margin: 0 auto 10px;
  }
}
</style>
